import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated';
import type { DocumentType } from '../../graphql/generated';
import PostModeToggle from '../../topbar/PostModeToggle';
import PostStatus from '../../topbar/PostStatus';
import Presence from '../Presence';
import useIsLayoutSize from '../utils/useIsLayoutSize';
import { LayoutSize } from '../utils/useLayoutSize';
import * as styles from './PostActions.module.scss';
import PostEditButton from './PostEditButton';

const POST_ACTIONS_FRAGMENT = gql(`
  fragment PostActions_post on Post {
    id
    externalPost {
      id
    }
    ...PostEditButton_post
  }
`);

interface PostActionsProps {
  post: DocumentType<typeof POST_ACTIONS_FRAGMENT>;
}

const PostActions = ({ post }: PostActionsProps) => {
  const isMobileLayout = useIsLayoutSize(LayoutSize.mobile);
  const readOnly = useAppSelector((state) => state.editor.readOnly);

  return (
    <>
      {isMobileLayout ? (
        <>
          <PostModeToggle mobile />
          <PostEditButton post={post} mobile />
        </>
      ) : (
        <>
          <div className={styles.statusContainer}>
            {!readOnly && <PostStatus />}
          </div>
          <div className={styles.presenceContainer}>
            <Presence />
          </div>
          <div className={styles.modeToggleContainer}>
            {!post.externalPost && <PostModeToggle />}
          </div>
          <div className={styles.modeToggleSeparator} />
          <PostEditButton post={post} />
        </>
      )}
    </>
  );
};

export default PostActions;
